import React from 'react';
import { Typography } from 'fmc-digital-common';
import { VStack, HStack, Stack, useMediaQuery } from 'native-base';
import { kebabCase } from 'lodash';
import NewLoanInProgressHeader from '../../organisms/NewLoanInProgressHeader';
const LoanSummaryData = ({
  data,
  screenFlag
}) => {
  const [isExtraLargeScreen] = useMediaQuery({
    maxWidth: 1024
  });
  if (screenFlag) {
    if (data?.length > 2) {
      const rowBreak = Math.round(data?.length / 2);
      return /*#__PURE__*/React.createElement(VStack, {
        space: 4
      }, /*#__PURE__*/React.createElement(NewLoanInProgressHeader, {
        header: "Loan Summary"
      }), /*#__PURE__*/React.createElement(Stack, {
        space: {
          base: 4,
          md: 3,
          lg: 4
        },
        direction: isExtraLargeScreen ? 'column' : 'row',
        width: 'auto'
      }, /*#__PURE__*/React.createElement(Stack, {
        space: {
          base: 4,
          md: 3,
          lg: 4
        },
        direction: isExtraLargeScreen ? 'row' : 'column'
      }, data?.map(({
        label,
        value
      }, index) => {
        return index < rowBreak && /*#__PURE__*/React.createElement(HStack, {
          flex: "1"
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "captionBold",
          accessibilityLabel: kebabCase(label),
          accessibilityRole: "text",
          testID: kebabCase(label),
          color: "darkGray.900"
        }, label, ' '), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption13",
          color: "darkGray.900"
        }, value));
      })), /*#__PURE__*/React.createElement(Stack, {
        space: {
          base: 4,
          md: 3,
          lg: 4
        },
        direction: isExtraLargeScreen ? 'row' : 'column'
      }, data?.map(({
        label,
        value
      }, index) => {
        return index >= rowBreak && /*#__PURE__*/React.createElement(HStack, {
          flex: "1"
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "captionBold",
          accessibilityLabel: kebabCase(label),
          accessibilityRole: "text",
          testID: kebabCase(label),
          color: "darkGray.900"
        }, label, ' '), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption13",
          color: "darkGray.900"
        }, value));
      }))));
    } else {
      return /*#__PURE__*/React.createElement(HStack, {
        space: 4,
        justifyContent: "space-between"
      }, /*#__PURE__*/React.createElement(NewLoanInProgressHeader, {
        header: "Loan Summary"
      }), /*#__PURE__*/React.createElement(HStack, {
        space: 4,
        alignItems: "center"
      }, data?.map(({
        label,
        value
      }, index) => {
        return /*#__PURE__*/React.createElement(HStack, {
          key: index
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "captionBold"
        }, label, " "), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption13"
        }, " ", value));
      })));
    }
  } else {
    return /*#__PURE__*/React.createElement(VStack, {
      space: 2
    }, data?.map(({
      label,
      value
    }) => {
      return /*#__PURE__*/React.createElement(HStack, null, /*#__PURE__*/React.createElement(Typography, {
        variant: "captionBold",
        accessibilityLabel: kebabCase(label),
        accessibilityRole: "text",
        testID: kebabCase(label),
        color: "darkGray.900"
      }, label, ' '), /*#__PURE__*/React.createElement(Typography, {
        variant: "caption13",
        color: "darkGray.900",
        accessibilityLabel: value,
        accessibilityRole: "text"
      }, value));
    }));
  }
};
export default LoanSummaryData;
//# sourceMappingURL=LoanSummaryData.js.map